// Mapas humanizados e helpers compartilhados entre os componentes de Suporte.
// O cliente nunca vê jargão de helpdesk — apenas labels simples.

export const STATUS_META = {
  OPEN: { label: "Aberto", emoji: "🔵", color: "#3498db", soft: "#e1efff" },
  IN_PROGRESS: { label: "Em andamento", emoji: "🟡", color: "#f39c12", soft: "#fdf2dd" },
  RESOLVED: { label: "Resolvido", emoji: "🟢", color: "#27ae60", soft: "#dff5e6" },
  CLOSED: { label: "Encerrado", emoji: "⚫", color: "#7f8c8d", soft: "#ecedee" },
};

// RESOLVED e CLOSED são exibidos como "Encerrado" para o cliente, mas a borda
// lateral do card usa a cor real do status para diferenciação visual sutil.
export const PRIORITY_META = {
  LOW: { label: "Baixa", color: "#7f8c8d", soft: "#ecedee", show: true },
  NORMAL: { label: "Normal", color: "#34495e", soft: "#eef1f4", show: false },
  HIGH: { label: "Alta", color: "#e67e22", soft: "#fce8d6", show: true },
  URGENT: { label: "Urgente", color: "#c0392b", soft: "#fbe3e0", show: true },
};

// Opções do select de criação, com labels humanizados (briefing).
export const PRIORITY_OPTIONS = [
  { value: "LOW", label: "Baixa — não está bloqueando meu trabalho" },
  { value: "NORMAL", label: "Normal — consegue esperar" },
  { value: "HIGH", label: "Alta — está impactando meu negócio" },
  { value: "URGENT", label: "Urgente — estou sem conseguir atender clientes" },
];

// Filtros (chips) → query ?status=. "Encerrados" agrupa RESOLVED + CLOSED na
// visão do usuário; o backend aceita múltiplos status separados por vírgula,
// então mandamos "CLOSED,RESOLVED" num único request.
export const STATUS_FILTERS = [
  { id: "ALL", label: "Todos", query: undefined },
  { id: "OPEN", label: "Abertos", query: "OPEN" },
  { id: "IN_PROGRESS", label: "Em andamento", query: "IN_PROGRESS" },
  { id: "CLOSED", label: "Encerrados", query: "CLOSED,RESOLVED" },
];

const RELATIVE_DIVISIONS = [
  { amount: 60, name: "seconds" },
  { amount: 60, name: "minutes" },
  { amount: 24, name: "hours" },
  { amount: 7, name: "days" },
  { amount: 4.34524, name: "weeks" },
  { amount: 12, name: "months" },
  { amount: Number.POSITIVE_INFINITY, name: "years" },
];

const rtf = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });

/** Timestamp relativo humanizado: "há 2 horas", "há 3 dias". */
export function relativeTime(dateInput) {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return "";
  let duration = (date.getTime() - Date.now()) / 1000;
  for (const division of RELATIVE_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.name);
    }
    duration /= division.amount;
  }
  return "";
}

/** Data absoluta curta: "15/05/2026". */
export function formatDate(dateInput) {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("pt-BR");
}
